import React from 'react';
import styled from 'styled-components';
import { SBox } from '@avalara/skylab-sdk/react';
const Wrapper = styled.div `
  display: inline-block;
  h2 {
    font-size: 23px;
    line-height: 30px;
  }
  p {
    font-size: 14px;
    line-height: 18px;
  }
`;
const BillingSummary = () => (React.createElement(Wrapper, null,
    React.createElement(SBox, { className: 'secondary pad-all-md' },
        React.createElement("h2", { "data-ref": 'buy.returns-thankyou.billing-summary.header', className: 'alt' }, "Billing Summary"),
        React.createElement("p", { "data-ref": 'buy.returns-thankyou.billing-summary.content', className: 'pad-top-sm' }, "Moving forward, your payment method will be charged for each return we handle."))));
export default BillingSummary;
